import React from "react";
import Header from "../Home/Header";
import Footer from "../Home/Footer";
import CaseStudiesOne from "./CaseStudiesOne";

function CaseStudies() {
  return (
    <div>
      <Header />
      <CaseStudiesOne />
      <Footer />
    </div>
  );
}

export default CaseStudies;
